export const PURCHASED_SEAT_STATUSES = [
  'sold',
  'reserved',
  'reservedForGroupPurchase',
  'pendingTransfer',
  'resaleAvailable',
]

export const getPurchaserClusterKey = (identity) => {
  if (!identity) return null
  if (identity.orderId != null) return `order:${identity.orderId}`
  return identity.purchaserKey ?? null
}

export const isPurchaserSeat = (seatId, seatIdentityById = {}) => {
  const identity = seatIdentityById?.[seatId]
  if (!identity) return false
  return (
    Boolean(getPurchaserClusterKey(identity)) &&
    PURCHASED_SEAT_STATUSES.includes(identity.onSaleStatus)
  )
}

/** clusterKey -> seatId[] */
export const buildPurchaserSeatClusters = (seatIdentityById = {}) => {
  const clusters = {}

  Object.entries(seatIdentityById).forEach(([seatId, identity]) => {
    if (!isPurchaserSeat(seatId, seatIdentityById)) return
    const key = getPurchaserClusterKey(identity)
    if (!key) return
    if (!clusters[key]) clusters[key] = []
    clusters[key].push(seatId)
  })

  return clusters
}

export const getClusterSeatIdsForSeat = (
  seatId,
  seatIdentityById = {},
  clusters = null
) => {
  const clusterMap = clusters ?? buildPurchaserSeatClusters(seatIdentityById)
  const key = getPurchaserClusterKey(seatIdentityById?.[seatId])
  if (!key) return []
  return clusterMap[key] || []
}
